import { createActionConst } from '../../../utils/action.utils';

const AGENDA_NAMESPACE = 'AGENDA';

export const STORE_AGENDA = createActionConst(AGENDA_NAMESPACE, 'STORE_AGENDA');
export const CLEAR_AGENDA = createActionConst(AGENDA_NAMESPACE, 'CLEAR_AGENDA');
